import './index.css'

function PageNavigator({ numberSelected }) {
    const items = [
        { src: './images/home-01-stroke-rounded.png', text: 'Your feed',url: '/feed' },
        { src: './images/linkedin-02-stroke-rounded.png', text: 'Your posts',url: '/ideas' },
        { src: './images/calendar-03-stroke-rounded.png', text: 'Your schedule',url: '/schedule' },
        { src: './images/apple-reminder-stroke-rounded.png', text: 'Your sites',url: '/sites' },
        { src: './images/add-team-stroke-rounded.png', text: 'Your voices',url: '/voices' },
        { src: './images/account-setting-02-Stroke-Rounded.png', text: 'Settings',url: '/settings' },

    ];

    return (
        <div className='nav-holder'>
        <div className='page-navigator'>
            {items.map((item, index) => (
                <a href={item.url}><div
                    key={index}
                    className={`navigation-item ${numberSelected === index ? 'selected-nav-item' : ''}`}
                >
                    <div className='navigation-item-icon-holder'>
                        <img className='navigation-item-icon' src={item.src} alt={item.text} />
                    </div>
                    <div className='navigation-item-text small-text'>{item.text}</div>
                </div></a>
            ))}
        </div>
        </div>
    );
}

export default PageNavigator;